import { render, staticRenderFns } from "./BindStaff.vue?vue&type=template&id=d4f589a0&"
import script from "./BindStaff.vue?vue&type=script&lang=js&"
export * from "./BindStaff.vue?vue&type=script&lang=js&"
import style0 from "./BindStaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports